import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Expression Edit";

const callExpressionEdit = async (
	messageId: string,
	jwt: string,
	expression: {
		$aaa: number;
		$eee: number;
		$woo: number;
		$wink: number;
		$blink: number;
		$smile: number;
		$eyebrow: number;
		$pupil_x: number;
		$pupil_y: number;
	},
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$image: imageBase64,
					...expression,
				},
				tool_document_id,
				jwt,
			};
			return fetchExpressionEdit(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchExpressionEdit(
	params: {
		inputs: {
			$image: string;
			$aaa: number;
			$eee: number;
			$woo: number;
			$wink: number;
			$blink: number;
			$smile: number;
			$eyebrow: number;
			$pupil_x: number;
			$pupil_y: number;
		};
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenExpressionEditMessage() {
	useListenFromRenderer([
		{
			key: "expressionEdit",
			onMessage: async (message) => {
				const success = await callExpressionEdit(
					message.id,
					message.values.jwt,
					{
						$aaa: message.values.aaa,
						$eee: message.values.eee,
						$woo: message.values.woo,
						$wink: message.values.wink,
						$blink: message.values.blink,
						$smile: message.values.smile,
						$eyebrow: message.values.eyebrow,
						$pupil_x: message.values.pupil_x,
						$pupil_y: message.values.pupil_y,
					},
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
